<script setup lang="ts">
    import {shoppingCartStore} from './Store.ts';

    const store = shoppingCartStore();
    let props = defineProps({
        longDisplayDeliveryDate: String,
    });
</script>

<template>
    <div>
        <div
            v-if="store.deliveryDate"
            class="greyInfoBox fs-14"
            id="shippingContainer">
            <i class="fa fa-truck col-green"></i>
            {{ __('De verwachte levertijd voor je bestelling is') }}
            <strong class="col-green">{{ store.deliveryDate }}</strong>
        </div>

        <!--        <div-->
        <!--            class="mao-notification warn alert fs-14"-->
        <!--            style="margin-bottom: 30px; padding: 30px">-->
        <!--            <i class="fa fa-exclamation-triangle"></i>-->
        <!--            <strong>Let op</strong>-->
        <!--            , in verband met de NAVO-top 2025 kunnen leveringen vertraagd zijn!-->
        <!--        </div>-->
    </div>
</template>

<style scoped></style>
